import { Injectable } from '@angular/core';
import { OrganizationService } from './organization.service';
import * as Parse from 'parse';

@Injectable()
export class PhotoService {

    constructor(private orgService: OrganizationService) {

    }

    fetchPhotosForProperty(property: Parse.Object) {
        const query: Parse.Query = new Parse.Query('Photo');

        query.equalTo('property', property);
        query.equalTo('organization', this.orgService.organization);
        query.descending('createdAt');

        return query.find();
    }

    async createPhoto(file: File, property: Parse.Object) {
        const parseFile: Parse.File = new Parse.File(file.name.replace(/[^a-zA-Z0-9]/g,'_'), file);
        const dimension = await this.getImageDimension(file);
        const photo: Parse.Object = new Parse.Object('Photo');

        photo.set('file', parseFile);
        photo.set('width', dimension.width);
        photo.set('height', dimension.height);
        photo.set('name', file.name);
        photo.set('type', file.type);
        photo.set('property', property);

        try {
            // Generate thumbnail
            const thubmnailBase64 = await this.generateThumbnail(file, [1020, 700]);

            if (thubmnailBase64) {
                const thumbnail: Parse.File = new Parse.File('thumb.png', { base64: thubmnailBase64 });
                photo.set('thumbnail', thumbnail);
            }
        } catch (error) {
            console.error(error);
            // Thumbnail creation can fail silently
        }

        return photo.save();
    }

    async getImageDimension(file: File): Promise<any> {
        return new Promise( (resolve) => {
            const reader = new FileReader();

            reader.onload = () => {
                const img = new Image();

                img.onload = () => {
                    resolve({
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    });
                };

                img.src = reader.result as string;
            };

            reader.readAsDataURL(file);
        });
    }

    generateThumbnail(file: File, boundBox: number[]): Promise<string> {
        if (!boundBox || boundBox.length !== 2) {
            throw new Error('You need to give the boundBox [w,h]');
        }

        const reader = new FileReader();
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d') as CanvasRenderingContext2D;

        return new Promise((resolve) => {
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    const scaleRatio = Math.min(...boundBox) / Math.max(img.width, img.height);
                    const w = img.width * scaleRatio;
                    const h = img.height * scaleRatio;
                    canvas.width = w;
                    canvas.height = h;
                    context.drawImage(img, 0, 0, w, h);

                    return resolve(canvas.toDataURL('image/png'));
                };
                (img as any).src = (event as any).target.result;
            };

            reader.readAsDataURL(file);
        });
    }
}
